import { currentLang } from '../../i18nInit'
import { Lang } from '../../services/api.types'

// Trimmed CLDR unit files generated by scripts/extract-cldr-units.js
// Contains only the 13 unit types we use, reducing ~4.6MB to ~240KB.
const getLocalizedUnits = (locale: Lang) => {
  try {
    switch (locale) {
      default:
      case Lang.EN:
        return require(`./cldr-units/en.json`)
      case Lang.AR:
        return require(`./cldr-units/ar.json`)
      case Lang.BG:
        return require(`./cldr-units/bg.json`)
      case Lang.BS:
        return require(`./cldr-units/bs.json`)
      case Lang.CS:
        return require(`./cldr-units/cs.json`)
      case Lang.DA:
        return require(`./cldr-units/da.json`)
      case Lang.DE:
        return require(`./cldr-units/de.json`)
      case Lang.EL:
        return require(`./cldr-units/el.json`)
      case Lang.ES:
        return require(`./cldr-units/es.json`)
      case Lang.ET:
        return require(`./cldr-units/et.json`)
      case Lang.FI:
        return require(`./cldr-units/fi.json`)
      case Lang.FR:
        return require(`./cldr-units/fr.json`)
      case Lang.HR:
        return require(`./cldr-units/hr.json`)
      case Lang.HE:
        return require(`./cldr-units/he.json`)
      case Lang.HU:
        return require(`./cldr-units/hu.json`)
      case Lang.ID:
        return require(`./cldr-units/id.json`)
      case Lang.IT:
        return require(`./cldr-units/it.json`)
      case Lang.JA:
        return require(`./cldr-units/ja.json`)
      case Lang.KO:
        return require(`./cldr-units/ko.json`)
      case Lang.LT:
        return require(`./cldr-units/lt.json`)
      case Lang.LV:
        return require(`./cldr-units/lv.json`)
      case Lang.NL:
        return require(`./cldr-units/nl.json`)
      case Lang.NO:
        return require(`./cldr-units/no.json`)
      case Lang.PL:
        return require(`./cldr-units/pl.json`)
      case Lang.PT:
        return require(`./cldr-units/pt-PT.json`)
      case Lang.PT_BR:
        return require(`./cldr-units/pt.json`)
      case Lang.RO:
        return require(`./cldr-units/ro.json`)
      case Lang.RU:
        return require(`./cldr-units/ru.json`)
      case Lang.SK:
        return require(`./cldr-units/sk.json`)
      case Lang.SL:
        return require(`./cldr-units/sl.json`)
      case Lang.SQ:
        return require(`./cldr-units/sq.json`)
      case Lang.SR:
        return require(`./cldr-units/sr.json`)
      case Lang.SV:
        return require(`./cldr-units/sv.json`)
      case Lang.TH:
        return require(`./cldr-units/th.json`)
      case Lang.TR:
        return require(`./cldr-units/tr.json`)
      case Lang.UK:
        return require(`./cldr-units/uk.json`)
      case Lang.VI:
        return require(`./cldr-units/vi.json`)
      case Lang.ZH_HANS:
        return require(`./cldr-units/zh-Hans.json`)
      case Lang.ZH_HANT:
        return require(`./cldr-units/zh-Hant.json`)
      case Lang.HI:
        return require(`./cldr-units/hi.json`)
      case Lang.BN:
        return require(`./cldr-units/bn.json`)
      case Lang.PA:
        return require(`./cldr-units/pa.json`)
      case Lang.UR:
        return require(`./cldr-units/ur.json`)
      case Lang.FA:
        return require(`./cldr-units/fa.json`)
      case Lang.MS:
        return require(`./cldr-units/ms.json`)
      case Lang.FIL:
        return require(`./cldr-units/fil.json`)
      case Lang.SW:
        return require(`./cldr-units/sw.json`)
      case Lang.HA:
        return require(`./cldr-units/ha.json`)
      case Lang.MY:
        return require(`./cldr-units/my.json`)
      case Lang.TA:
        return require(`./cldr-units/ta.json`)
    }
  } catch (ex) {
    console.error(`Units for ${locale} does not exist!`)
    return undefined
  }
}

const unitsShort = getLocalizedUnits(currentLang)

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getLocalizedDisplayUnit = (name: string, fallback: string) => {
  // @ts-ignore
  return capitalizeFirstLetter(unitsShort?.long[name]?.displayName || fallback)
}

export const getLocalizedDisplayUnitShort = (name: string, fallback: string) => {
  // @ts-ignore
  return capitalizeFirstLetter(unitsShort?.short[name]?.displayName || fallback)
}

// Test if units for all languages exists.
/*import { languages } from '../../i18nInit'
languages.forEach(({ lang, name }, index) => {
  name = 'length-point'
  const unitsShort2 = getLocalizedUnits(lang)
  console.log(lang, unitsShort2?.short[name]?.['unitPattern-count-other'])
})*/
//languages.forEach(({ lang, name }, index) => getLocalizedUnits(lang))

export const getLocalizedCountUnit = (name: string, fallback: string, length?: string) => {
  // @ts-ignore
  if (!length) length = 'short'
  return unitsShort?.[length]?.[name]?.['unitPattern-count-other']?.replace('{0}', '').trim() || fallback
}

export const unitsDisplayDurationMinuteLong = getLocalizedDisplayUnit('duration-minute', 'Minutes')
export const unitsDisplayDurationCalorieLong = getLocalizedDisplayUnit('energy-calorie', 'Calories')

export const unitsCountDurationDayLong = getLocalizedCountUnit('duration-day', 'days', 'long')
export const unitsCountDurationMinuteLong = getLocalizedCountUnit('duration-minute', 'minutes', 'long')
export const unitsCountEnergyCalorieLong = getLocalizedCountUnit('energy-calorie', 'calories', 'long')

export const unitsCountEnergyKilocalorieShort = getLocalizedCountUnit('energy-kilocalorie', 'kcal')
export const unitsCountMassKilogramShort = getLocalizedCountUnit('mass-kilogram', 'kg')
export const unitsCountMassPoundShort = getLocalizedCountUnit('mass-pound', 'lb')
export const unitsCountLengthFootShort = getLocalizedCountUnit('length-foot', 'ft')
export const unitsCountLengthInchShort = getLocalizedCountUnit('length-inch', 'in')
export const unitsCountLengthCentimeterShort = getLocalizedCountUnit('length-centimeter', 'cm')
export const unitsCountLengthKilometerShort = getLocalizedCountUnit('length-kilometer', 'km')
export const unitsCountLengthMileShort = getLocalizedCountUnit('length-mile', 'mi')
export const unitsCountDurationMinuteShort = getLocalizedCountUnit('duration-minute', 'minutes')
export const unitsCountDurationHourShort = currentLang === Lang.ET ? 'h' : getLocalizedCountUnit('duration-hour', 'hr')

export const unitsCountPointsShortFunc = (value?: number) => {
  if ([Lang.EN, Lang.FR].includes(currentLang)) {
    return value === 1 ? `point` : `points`
  } else if (currentLang === Lang.ET) {
    return value === 1 ? `punkt` : `punkti`
  } else if (currentLang === Lang.VI) {
    return `điểm`
  }
  return getLocalizedCountUnit('length-point', 'points', 'short')
}
export const unitsCountPointsShort = unitsCountPointsShortFunc()
export const unitsDisplayPointsShort =
  currentLang === Lang.FR
    ? `Points`
    : currentLang === Lang.ET
      ? 'Punktid'
      : getLocalizedDisplayUnitShort('length-point', 'Points')
